import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';
import { Skin } from '../../../models/common/Skin';
import clsx from 'clsx';
import themePrimary from '../../../styles/themePrimary';

const useStyles = makeStyles({  
  button: {
    backgroundColor: props => (props as Skin).primary_main_color + ' !important',
    color: themePrimary.palette.primary.contrastText,    
  },
  buttonAlternate: {
    color: props => (props as Skin).primary_main_color,   
    border: props => '3px solid ' + (props as Skin).primary_main_color,  
    backgroundColor: themePrimary.palette.primary.contrastText,
  },
  buttonDisabled: {
    backgroundColor: themePrimary.palette.secondary.main + ' !important',
    color: themePrimary.palette.primary.contrastText,    
  },
  buttonContainer: {
    textAlign: 'center',
  },
});

const FullWidthButtonInternal = withStyles((themePrimary) => ({
  root: {
    color: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '90%',
    height: '60px',
    borderRadius: '60px',
  },
}))(Button);

const FullWidthButtonInternalSmall = withStyles((themePrimary) => ({
  root: {
    color: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '94%',
    height: '48px',
    borderRadius: '10px',
  },
}))(Button);

const FullWidthButtonInternalLargeNotRounded = withStyles((themePrimary) => ({
  root: {
    color: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '94%',
    height: '60px',
    borderRadius: '10px',
  },
}))(Button);

const FullWidthButtonInternalAlternate = withStyles((themePrimary) => ({
  root: {
    color: props => (props as Skin).primary_main_color, 
    border: props => '3px solid ' + (props as Skin).primary_main_color,   
    backgroundColor: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '90%',
    height: '60px',
    borderRadius: '60px',
  },
}))(Button);

const FullWidthButtonInternalAlternateSmall = withStyles((themePrimary) => ({
  root: {
    color: props => (props as Skin).primary_main_color,     
    border: props => '3px solid ' + (props as Skin).primary_main_color,
    backgroundColor: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '94%',
    height: '48px',
    borderRadius: '10px',
  },
}))(Button);

const FullWidthButtonInternalAlternateLargeNotRounded = withStyles((themePrimary) => ({
  root: {
    color: props => (props as Skin).primary_main_color, 
    border: props => '3px solid ' + (props as Skin).primary_main_color,   
    backgroundColor: themePrimary.palette.primary.contrastText,
    boxShadow: 'none',
    fontSize: themePrimary.typography.h5.fontSize,
    width: '94%',
    height: '60px',
    borderRadius: '10px',
  },
}))(Button);

export enum FullWidthButtonSize {
  Small = 1,
  Large = 2,
  LargeNotRounded = 3,
}

export type FullWidthButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface FullWidthButtonProps {
    label: string,
    disabled: boolean,
    size: FullWidthButtonSize,
    alternateColor: boolean,
    onClickHandler: FullWidthButtonClickHandler
}

export default function FullWidthButton(props: FullWidthButtonProps) {
    const { label, disabled, size, alternateColor, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

  return (
    <div className={classes.buttonContainer}>
      {!alternateColor && size === FullWidthButtonSize.Large &&
        <FullWidthButtonInternal 
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.button]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternal>      
      }
      {alternateColor  && size === FullWidthButtonSize.Large &&
        <FullWidthButtonInternalAlternate
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.buttonAlternate]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternalAlternate> 
      }
      {!alternateColor && size === FullWidthButtonSize.Small &&
        <FullWidthButtonInternalSmall
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.button]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternalSmall>      
      }
      {alternateColor  && size === FullWidthButtonSize.Small &&
        <FullWidthButtonInternalAlternateSmall
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.buttonAlternate]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternalAlternateSmall> 
      }
      {!alternateColor && size === FullWidthButtonSize.LargeNotRounded &&
        <FullWidthButtonInternalLargeNotRounded
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.button]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternalLargeNotRounded>      
      }
      {alternateColor  && size === FullWidthButtonSize.LargeNotRounded &&
        <FullWidthButtonInternalAlternateLargeNotRounded
          className={clsx({[classes.buttonDisabled]: disabled,
            [classes.buttonAlternate]: !disabled})}
          disabled={disabled}
          variant="contained" 
          onClick={onClickHandler}>
          {label}
        </FullWidthButtonInternalAlternateLargeNotRounded> 
      }
    </div>
  );
}